<template>
  <div>
    <table class="data-table statistics-table">
      <thead>
      <tr>
        <th>Платформа</th>
        <th>Пройдено (%)</th>
        <th>Дропнуто (%)</th>
        <th>Рерольнуто</th>
        <th>Всего времени</th>
        <th>Среднее время прохождения</th>
        <th>Самая долгая игра (время)</th>
        <th>Самая короткая игра (время)</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(platformItem, index) in statistics.platformItems" :key="index">
        <td :title="platformItem.fullPlatformName">{{ platformItem.platformName }}</td>
        <td>{{ platformItem.completed }} ({{ platformItem.completedPercentage }}%)</td>
        <td>{{ platformItem.dropped }} ({{ platformItem.droppedPercentage }}%)</td>
        <td>{{ platformItem.rerolled }}</td>
        <td>{{ platformItem.totalTimeFormatted }}</td>
        <td>{{ platformItem.averageTimeFormatted }}</td>
        <td>
          <template v-if="platformItem.longestGame">
            {{ platformItem.longestGame.gameName }} ({{ platformItem.longestGame.durationFormatted }})
          </template>
        </td>
        <td>
          <template v-if="platformItem.shortestGame">
            {{ platformItem.shortestGame.gameName }} ({{ platformItem.shortestGame.durationFormatted }})
          </template>
        </td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <td>Всего</td>
        <td>{{statistics.totalCompleted}} ({{statistics.totalCompletedPercentage}}%)</td>
        <td>{{statistics.totalDropped}} ({{statistics.totalDroppedPercentage}}%)</td>
        <td>{{statistics.totalRerolled}}</td>
        <td>{{statistics.totalTimeFormatted}}</td>
        <td>{{statistics.averageTimeFormatted}}</td>
        <td>
          <template v-if="statistics.longestGame">
            {{ statistics.longestGame.gameName }} ({{ statistics.longestGame.durationFormatted }})
          </template>
        </td>
        <td>
          <template v-if="statistics.shortestGame">
            {{ statistics.shortestGame.gameName }} ({{ statistics.shortestGame.durationFormatted }})
          </template>
        </td>
      </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import ApiService from "@/services/api-service";

export default {
  name: "RggStatistics",
  data: function () {
    return {
      statistics: {
        platformItems: [],
        totalCompleted: null,
        totalCompletedPercentage: null,
        totalDropped: null,
        totalDroppedPercentage: null,
        totalRerolled: null,
        totalTimeFormatted: null,
        averageTimeFormatted: null,
        longestGame: null,
        shortestGame: null,
      }
    }
  },
  props: ["seasonNumber"],
  mounted() {
    ApiService.get(`rgg/season/${this.seasonNumber}/statistics`).then(response => {
      this.statistics = response.data
    })
  }
}
</script>

<style scoped>
.statistics-table tfoot tr{
  background: #0a0a0a;
}
</style>